module.exports = __webpack_public_path__ + "img/Telephone.214429e1.svg";